export default [
    { value: 0, label: '政府部门' },
    { value: 1, label: '党群部门' },
    { value: 2, label: '政法司法部门' },
];
